module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "images3"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Image",
      "src": "images/img2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("DISCOVER THE LONG-LOST SKILLS OF SELF-RELIANCE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("M")]), _vm._v("y name is Caleb Warnock, and I’ve been working for years to learn how to return to forgotten skills, the skills of our ancestors. As our world becomes increasingly unstable, self-reliance becomes invaluable. Throughout this series, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Backyard Renaissance")]), _vm._v(", I will share with you the lost skills of self-sufficiency and healthy living. Come with me and other do-it-yourself experimenters, and rediscover the joys and successes of simple self-reliance.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02c97b47","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/discover.vue
// module id = 60
// module chunks = 0